import { linksArray } from "../../components/SideDrawer/NavListItems/NavListArray";

const reportDisplayNameLookup = (reportName) => {
    // Search both the standard Reports menu and the DW Reports menu, since
    // Redshift-backed reports (e.g. ValidationStatementRedshift) live under
    // dwReports and would otherwise fall back to the raw report name.
    const candidates = [
        ...Object.values(linksArray.reports?.children ?? {}),
        ...Object.values(linksArray.dwReports?.children ?? {}),
    ];
    const match = candidates.find(
        (child) => child.path?.split('/').pop().toLowerCase() === reportName?.toLowerCase()
    );
    return match?.text ?? reportName;
}

export default reportDisplayNameLookup;